export const associatedTasksOutsideRangeHeader = 'OUTSIDE THE MILESTONE\'S TIME RANGE';

export const associatedTasksOutsideRangeGuideline = 'Tasks have start and/or end dates that fall outside the milestone’s time range. This may affect milestone progress and overall project tracking.';
